import React from "react";
import Header from "./components/organisms/Header";
import Main from "./components/organisms/Main";
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <div>
        <Header />
        <Main />
      </div>
    </QueryClientProvider>
  );
};

export default App;
